import styled from 'styled-components';
import fonts from '../../ui/fonts';
import { colors } from '../../ui/design-tokens';
import { media, space, rems } from '../../ui/helpers';

const Module = styled.div`
  padding: ${space(6)} 0;

  ${media.min('medium')`
    padding: ${space(8)} 0;
  `}
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const News = styled.div`
  display: flex;
  padding: ${space(3)} 0;
  flex-direction: column;
  max-width: ${rems(395)};
  width: 100%;

  &:first-child {
    padding-top: 0;
  }

  .contentZone {
    display: flex;
    flex-direction: column;

    .newsTitle {
      ${fonts.bodyMD};
      margin-top: ${space(3)};
      margin-bottom: ${space(1)};
    }

    .abstract {
      ${fonts.bodySM};
      margin-bottom: ${space(2)};
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 6;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .date {
      ${fonts.bodyXSM};
    }
  }

  .imageZone {
    order: -1;

    .image {
      cursor: pointer;
      width: 100%;
    }
  }

  border-bottom: 1px solid ${colors.neutral[300]};

  ${media.min('medium')`
    flex-direction: row;
    max-width: none;

    .contentZone {
      margin-right: ${space(2)};
      width: calc(65% - ${space(2)});

      .newsTitle {
        margin-top: 0;
      }

      .abstract {
        -webkit-line-clamp: 3;
      }
    }

    .imageZone {
      order: initial;
      width: 35%;
    }
  `}
`;

const Pagination = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: ${space(8)};
  width: 100%;

  .btn {
    align-items: center;
    background: ${colors.neutral[200]};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    height: ${rems(38)};
    margin: 0 ${rems(12)};
    width: ${rems(38)};

    .svg {
      height: ${rems(8)};
      width: ${rems(12)};
      transform: rotate(-90deg);

      path {
        fill: ${colors.tweens[900]};
      }
    }

    &.double {
      .svg:first-child {
        transform: translate(3px) rotate(-90deg);
      }

      .svg:last-child {
        transform: translate(-3px) rotate(-90deg);
      }
    }

    &.reverse {
      .svg {
        transform: rotate(90deg);
      }

      &.double {
        .svg:first-child {
          transform: translate(3px) rotate(90deg);
        }

        .svg:last-child {
          transform: translate(-3px) rotate(90deg);
        }
      }
    }

    &.active {
      background: ${colors.tweens[300]};
      cursor: pointer;

      &:hover {
        background: ${colors.tweens[500]};
      }
    }
  }

  .currentPage {
    ${fonts.buttonSM};
    margin: 0 ${rems(12)};
  }

  ${media.min('medium')`
    .btn {
      &:first-child {
        margin-right: ${rems(4)};
      }

      &:last-child {
        margin-left: ${rems(4)};
      }
    }
  `}
`;

export { Module, List, News, Pagination };
